export const TEST_ID = 'serviceIntervalsModalFooter';

export const CANCEL_BUTTON_TEST_ID = 'serviceIntervalsModalFooterCancelButton';

export const SAVE_BUTTON_TEST_ID = 'serviceIntervalsModalFooterSaveButton';
